






import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import AdminCampaignCancellationDialog
  from '@/modules/base-campaign/components/admin/AdminCampaignCancellationDialog.vue'
import AdminCampaignCompleteButton from '@/modules/base-campaign/components/admin/AdminCampaignCompleteButton.vue'
import AdminCampaignDeleteButton from '@/modules/base-campaign/components/admin/AdminCampaignDeleteButton.vue'
import { InvoiceResourceTypeInAdmin } from '@/modules/invoice/models/invoice-reource.model'

@Component({
  components: { AdminCampaignCancellationDialog, AdminCampaignCompleteButton, AdminCampaignDeleteButton }
})
export default class AdminInvoiceShowTabularActions extends Vue {
  constructor() {
    super()
  }

  @Prop() invoice: InvoiceResourceTypeInAdmin

}
